import React, { useContext } from 'react';
import Select from '../../../components/form/Select';
import SiteContext from '../../../contexts/site/siteContext';

const Capacity = () => {

    const siteContext = useContext(SiteContext);

    const changeCapacityCollection = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, capacity_collection: value });
    }
    const changeCapacityDelivery = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, capacity_delivery: value });
    }
    const changeCapacityCatering = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, capacity_catering: value });
    }
    const changeCapacityVenues = (value: number) => {
        siteContext.updateSite({ ...siteContext.site, capacity_venues: value });
    }

    if ( !siteContext.site || ( !siteContext.site.see_capacity_collection && !siteContext.site.see_capacity_delivery && !siteContext.site.see_capacity_catering && !siteContext.site.see_capacity_venues ) ) {
        return null;
    }

    let capacityOptionsCollection: any = {
        99: 'No Limits',
        1: '1 order',
        2: '2 orders',
        3: '3 orders',
        4: '4 orders',
        5: '5 orders',
        10: '10 orders',
        15: '15 orders',
        20: '20 orders',
        25: '25 orders',
        30: '30 orders',
        35: '35 orders',
        40: '40 orders',
        45: '45 orders',
        50: '50 orders'
    };

    let capacityOptionsDelivery: any = {
        99: 'No Limits',
        1: '1 order',
        2: '2 orders',
        3: '3 orders',
        4: '4 orders',
        5: '5 orders',
        10: '10 orders',
        15: '15 orders',
        20: '20 orders',
        25: '25 orders',
        30: '30 orders',
        35: '35 orders',
        40: '40 orders',
        45: '45 orders',
        50: '50 orders'
    };

    let capacityOptionsCatering: any = {
        99: 'No Limits',
        1: '1 order',
        2: '2 orders',
        3: '3 orders',
        4: '4 orders',
        5: '5 orders',
        10: '10 orders',
        15: '15 orders',
        20: '20 orders',
        25: '25 orders',
        30: '30 orders',
        35: '35 orders',
        40: '40 orders',
        45: '45 orders',
        50: '50 orders'
    };

    let capacityOptionsVenues: any = {
        99: 'No Limits',
        1: '1 order',
        2: '2 orders',
        3: '3 orders',
        4: '4 orders',
        5: '5 orders',
        10: '10 orders',
        15: '15 orders',
        20: '20 orders',
        25: '25 orders',
        30: '30 orders',
        35: '35 orders',
        40: '40 orders',
        45: '45 orders',
        50: '50 orders'
    };

    // If current value is not in prepOptions, then append as a new option
    if ( !(siteContext.site.capacity_collection in capacityOptionsCollection)) {
        capacityOptionsCollection = {
            ...capacityOptionsCollection,
            [siteContext.site.capacity_collection]: `${siteContext.site.capacity_collection} orders`
        }
    }
    if ( !(siteContext.site.capacity_delivery in capacityOptionsDelivery)) {
        capacityOptionsDelivery = {
            ...capacityOptionsDelivery,
            [siteContext.site.capacity_delivery]: `${siteContext.site.capacity_delivery} orders`
        }
    }
    if ( !(siteContext.site.capacity_catering in capacityOptionsCatering)) {
        capacityOptionsCatering = {
            ...capacityOptionsCatering,
            [siteContext.site.capacity_catering]: `${siteContext.site.capacity_catering} orders`
        }
    }
    if ( !(siteContext.site.capacity_venues in capacityOptionsVenues)) {
        capacityOptionsVenues = {
            ...capacityOptionsVenues,
            [siteContext.site.capacity_venues]: `${siteContext.site.capacity_venues} orders`
        }
    }

    const optionsCollection = Object.keys(capacityOptionsCollection).map((key) => (
        <option key={key} value={key}>{capacityOptionsCollection[key] as typeof capacityOptionsCollection}</option>
    ));

    const optionsDelivery = Object.keys(capacityOptionsDelivery).map((key) => (
        <option key={key} value={key}>{capacityOptionsDelivery[key] as typeof capacityOptionsDelivery}</option>
    ));

    const optionsCatering = Object.keys(capacityOptionsCatering).map((key) => (
        <option key={key} value={key}>{capacityOptionsCatering[key] as typeof capacityOptionsCatering}</option>
    ));

    const optionsVenues = Object.keys(capacityOptionsVenues).map((key) => (
        <option key={key} value={key}>{capacityOptionsVenues[key] as typeof capacityOptionsVenues}</option>
    ));

    return (
        <>
            <b className="text-muted">Orders per time slot</b>

            { siteContext.collectionEnabled && siteContext.site.see_capacity_collection ?
                <Select
                    label="Collection"
                    options={optionsCollection}
                    value={siteContext.site.capacity_collection}
                    handleChange={changeCapacityCollection}
                /> : null}

            { siteContext.deliveryEnabled && siteContext.site.see_capacity_delivery ?
                <Select
                    label="Delivery"
                    options={optionsDelivery}
                    value={siteContext.site.capacity_delivery}
                    handleChange={changeCapacityDelivery}
                /> : null }

            { siteContext.cateringEnabled && siteContext.site.see_capacity_catering ?
                <Select
                    label="Catering"
                    options={optionsCatering}
                    value={siteContext.site.capacity_catering}
                    handleChange={changeCapacityCatering}
                /> : null }

            { siteContext.venuesEnabled && siteContext.site.see_capacity_venues ?
                <Select
                    label="Venues"
                    options={optionsVenues}
                    value={siteContext.site.capacity_venues}
                    handleChange={changeCapacityVenues}
                /> : null }

            <hr/>
        </>
    );
}

export default Capacity;
